import React, { Component } from 'react';
import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import groupBy from 'lodash/groupBy';
import remove from 'lodash/remove';
import './Feed.css';
import ProfileIcon from '../../components/ProfileIcon';
import MessageForm from '../../components/MessageForm';
import FeedList from '../../components/FeedList';
import FeedModal from '../../components/FeedModal';
import findIndex from 'lodash/findIndex';
import { graphql, compose, withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { userShape, wallPostShape } from '../../utils/shapes';
import { ApolloError } from 'apollo-client';
import { getUserData } from '../../utils/graphQLFunctions';
import { MESSAGE_TYPE_POST } from '../../components/MessageForm';
import { fromJS } from 'immutable';
import fragments from '../../utils/graphql/fragments';
import { USER_QUERY } from '../../utils/graphql/queries';
import { isMobile } from '../../utils/functions';

class Feed extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: '',
      postsToAnimate: [],
      commentsToAnimate: [],
      showModal: false
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.addComment = this.addComment.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.onDeletePost = this.onDeletePost.bind(this);
    this.onDeleteComment = this.onDeleteComment.bind(this);
    this.onPostAnimationComplete = this.onPostAnimationComplete.bind(this);
    this.onCommentAnimationComplete = this.onCommentAnimationComplete.bind(
      this
    );
    this.onPinWallPost = this.onPinWallPost.bind(this);
    this.onUnpinWallPost = this.onUnpinWallPost.bind(this);
    this.onLikePost = this.onLikePost.bind(this);
    this.onUnlikePost = this.onUnlikePost.bind(this);
    this.onLikeComment = this.onLikeComment.bind(this);
    this.onUnlikeComment = this.onUnlikeComment.bind(this);

    this.unsubscribeFromNewData = () => {};
  }

  componentDidMount() {
    this.unsubscribeFromNewData = this.props.subscribeToNewData(
      post => {
        this.setState({
          postsToAnimate: fromJS(this.state.postsToAnimate)
            .push(post)
            .toJS()
        });
      },
      comment => {
        this.setState({
          commentsToAnimate: fromJS(this.state.commentsToAnimate)
            .push(comment)
            .toJS()
        });
      }
    );
  }

  componentWillUnmount() {
    this.unsubscribeFromNewData();
    this.unsubscribeFromNewData = () => {};
  }

  handleChange(event) {
    this.setState({
      message: event.target.value
    });
  }

  handleKeyDown(event) {
    if (event.key === 'Enter' && event.shiftKey === false) {
      this.handleSubmit(event);
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    const message = this.state.message.replace(/\n\s*\n\s*\n/g, '\n\n');
    if (message.trim()) {
      this.props.makeWallPost(message);
      this.setState({ message: '' });
      return true;
    }
    return false;
  }

  addComment(postId, message) {
    message = message.replace(/\n\s*\n\s*\n/g, '\n\n');
    if (message.trim()) {
      this.props.makeWallComment(postId, message);
      return true;
    }
    return false;
  }

  onDeletePost(post) {
    this.props.deleteWallPost(post);
  }

  onDeleteComment(postId, comment) {
    this.props.deleteWallComment(postId, comment);
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  openModal(event) {
    event.preventDefault();
    this.setState({ showModal: true });
  }

  onPostAnimationComplete(post) {
    this.setState({
      postsToAnimate: filter(this.state.postsToAnimate, item => {
        return post.id !== item.id;
      })
    });
  }

  onCommentAnimationComplete(comment) {
    this.setState({
      commentsToAnimate: fromJS(this.state.commentsToAnimate)
        .filter(item => {
          return comment.id !== item.get('id');
        })
        .toJS()
    });
  }

  onPinWallPost(post) {
    let previousPinnedPost = filter(this.props.postData.posts.posts, item => {
      return item.isPinned;
    });

    if (previousPinnedPost && previousPinnedPost.length > 0) {
      this.props.unpinWallPost(previousPinnedPost[0]).then(() => {
        this.props.pinWallPost(post);
      });
    } else {
      this.props.pinWallPost(post);
    }
  }

  onUnpinWallPost(post) {
    this.props.unpinWallPost(post);
  }

  onLikePost(post) {
    this.props.likePost(post);
  }

  onUnlikePost(post) {
    this.props.unlikePost(post);
  }

  onLikeComment(comment) {
    this.props.likeComment(comment);
  }

  onUnlikeComment(comment) {
    this.props.unlikeComment(comment);
  }

  render() {
    const {
      narrow = false,
      userData,
      postData,
      makeWallPost,
      location
    } = this.props;

    return (
      <div className="feed">
        <div className={`feed-wrapper ${narrow ? 'narrow' : ''}`}>
          <div className="feed-comment-container initial-comment">
            <MessageForm
              onSubmit={this.handleSubmit}
              onChange={this.handleChange}
              onKeyDown={this.handleKeyDown}
              onClick={this.openModal}
              message={this.state.message}
              placeholder={MESSAGE_TYPE_POST}
            />
          </div>
          <FeedModal
            show={this.state.showModal}
            onHide={this.closeModal}
            makeWallPost={makeWallPost}
          />
          <div className="feed-list-container">
            {postData && (
              <FeedList
                user={userData.user}
                posts={(postData.posts && postData.posts.posts) || []}
                loading={postData.loading}
                error={postData.error || userData.error}
                addComment={this.addComment}
                onDeletePost={this.onDeletePost}
                onDeleteComment={this.onDeleteComment}
                loadMorePosts={this.props.loadMorePosts}
                loadMoreComments={this.props.loadMoreComments}
                hasAnyMore={!!postData.posts && postData.posts.hasAnyNext}
                postsToAnimate={this.state.postsToAnimate}
                onPostAnimationComplete={this.onPostAnimationComplete}
                commentsToAnimate={this.state.commentsToAnimate}
                onCommentAnimationComplete={this.onCommentAnimationComplete}
                onPinWallPost={this.onPinWallPost}
                onUnpinWallPost={this.onUnpinWallPost}
                onLikePost={this.onLikePost}
                onUnlikePost={this.onUnlikePost}
                onLikeComment={this.onLikeComment}
                onUnlikeComment={this.onUnlikeComment}
              />
            )}
          </div>
        </div>
        <div className="profile">
          <ProfileIcon
            size={isMobile(location.pathname) ? 40 : 75}
            src={this.props.userData.user && this.props.userData.user.avatarUrl}
            border="border"
          />
        </div>
      </div>
    );
  }
}

Feed.propTypes = {
  narrow: PropTypes.bool,
  userData: PropTypes.shape({
    user: userShape,
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.instanceOf(Error),
      PropTypes.instanceOf(ApolloError)
    ])
  }),
  postData: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.instanceOf(Error),
      PropTypes.instanceOf(ApolloError)
    ]),
    posts: PropTypes.shape({
      posts: PropTypes.arrayOf(wallPostShape),
      startPostId: PropTypes.number,
      endPostId: PropTypes.number,
      hasAnyNext: PropTypes.bool
    })
  }),
  subscribeToNewData: PropTypes.func
};

const QUERY_WALL_POSTS = gql`
  query MyGetPostsWithComments($posts: GetPosts!, $comments: GetComments!) {
    posts(posts: $posts) {
      posts {
        ...PostWithComments
      }
      ...PostPaginationFields
    }
  }
  ${fragments.postPagination}
  ${fragments.postWithComments}
`;

const QUERY_WALL_POSTS_DEFAULT_VARS = {
  posts: { postCount: 10, mostRecentLikedByCount: 10 },
  comments: { commentCount: 10, mostRecentLikedByCount: 10 }
};

const QUERY_WALL_COMMENTS = gql`
    query MyGetPostComments($comments: GetComments!) {
        comments(comments: $comments) {
            comments {
                ...CommentFields
            }
            ...CommentPaginationFields
        }
    }
    ${fragments.comment}
    ${fragments.commentPagination}
`;

const MUTATION_MAKE_WALL_POST = gql`
  mutation MyMakePost($post: MakePost!, $posts: GetPosts!) {
    makePost(post: $post) {
      ...PostFields
    }
  }
  ${fragments.post}
`;

const MUTATION_DELETE_WALL_POST = gql`
  mutation MyDeletePost($post: DeletePost!) {
    deletePost(post: $post) {
      id
    }
  }
`;

const MUTATION_MAKE_WALL_COMMENT = gql`
  mutation MyMakeComment($comment: MakeComment!) {
    makeComment(comment: $comment) {
      ...CommentFields
    }
  }
  ${fragments.comment}
`;

const MUTATION_DELETE_WALL_COMMENT = gql`
  mutation MyDeletePostComment($comment: DeleteComment!) {
    deleteComment(comment: $comment) {
      id
      postId
    }
  }
`;

const MUTATION_PIN_WALL_POST = gql`
  mutation MyPinPost($post: PinPost!, $posts: GetPosts!) {
    pinPost(post: $post) {
      post {
        ...PostFields
      }
    }
  }
  ${fragments.post}
`;

const MUTATION_UNPIN_WALL_POST = gql`
  mutation MyUnpinPost($post: UnpinPost!) {
    unpinPost(post: $post) {
      id
    }
  }
`;

const MUTATION_LIKE_WALL_POST = gql`
  mutation MyLikePost($like: LikePost!) {
    likePost(like: $like) {
      id
    }
  }
`;

const MUTATION_UNLIKE_WALL_POST = gql`
  mutation MyUnlikePost($unlike: UnlikePost!) {
    unlikePost(unlike: $unlike) {
      id
    }
  }
`;

const MUTATION_LIKE_COMMENT = gql`
  mutation MyLikeComment($like: LikeComment!) {
    likeComment(like: $like) {
      id
      postId
    }
  }
`;

const MUTATION_UNLIKE_COMMENT = gql`
  mutation MyUnikeComment($unlike: UnlikeComment!) {
    unlikeComment(unlike: $unlike) {
      id
      postId
    }
  }
`;

const SUBSCRIPTION_WALL_UPDATES = gql`
  subscription WallUpdates($posts: GetPosts!, $comments: GetComments!) {
    wallUpdates {
      posts {
        ...PostWithComments
      }
      comments {
        ...CommentFields
      }
      deletedPosts {
        id
        imageUrl
      }
      deletedComments {
        id
        postId
      }
      pinnedPosts {
        post {
          ...PostWithComments
        }
      }
      unpinnedPosts {
        id
      }
      likedPosts {
        id
        likedBy {
          ...UserIdAndDisplayFields
        }
      }
      unlikedPosts {
        id
        userId
      }
      likedComments {
        id
        postId
        likedBy {
          ...UserIdAndDisplayFields
        }
      }
      unlikedComments {
        id
        postId
        userId
      }
    }
  }
  ${fragments.postWithComments}
  ${fragments.comment}
`;

export default withApollo(
  compose(
    // User data must be composed before makeWallPost mutation.
    getUserData({
      name: 'userData'
    }),
    graphql(QUERY_WALL_POSTS, {
      name: 'postData',
      options: {
        variables: QUERY_WALL_POSTS_DEFAULT_VARS,
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true
      },
      props({ ownProps, userData, postData }) {
        return {
          userData: ownProps.userData,
          postData,
          loadMorePosts: () => {
            return postData.fetchMore({
              query: QUERY_WALL_POSTS,
              variables: {
                posts: {
                  postCount: 10,
                  beforeId: postData.posts.endId,
                  mostRecentLikedByCount: 10
                },
                comments: {
                  commentCount: 10,
                  mostRecentLikedByCount: 10
                }
              },
              updateQuery: (previousResult, { fetchMoreResult }) => {
                if (!fetchMoreResult) {
                  return previousResult;
                }
                return fromJS(fetchMoreResult)
                  .updateIn(['posts', 'posts'], list =>
                    fromJS(previousResult.posts.posts).concat(list)
                  )
                  .toJS();
              }
            });
          },
          loadMoreComments: (post, callback) => {
            return postData.fetchMore({
              query: QUERY_WALL_COMMENTS,
              variables: {
                comments: {
                  commentCount: 5,
                  beforeId: post.comments.endId,
                  postId: post.id,
                  mostRecentLikedByCount: 10
                }
              },
              updateQuery: (previousResult, { fetchMoreResult }) => {
                const postIdx = findIndex(
                  previousResult.posts.posts,
                  item => item.id === post.id
                );

                callback(fetchMoreResult.comments.comments.length);

                return fromJS(previousResult)
                  .updateIn(['posts', 'posts', postIdx, 'comments'], item => {
                    return item
                      .update('comments', list => {
                        return list.concat(
                          fromJS(fetchMoreResult.comments.comments)
                        );
                      })
                      .set('endId', fetchMoreResult.comments.endId)
                      .set('hasAnyNext', fetchMoreResult.comments.hasAnyNext);
                  })
                  .toJS();
              }
            });
          },
          subscribeToNewData: (onNewPost, onNewComment) => {
            return postData.subscribeToMore({
              document: SUBSCRIPTION_WALL_UPDATES,
              variables: QUERY_WALL_POSTS_DEFAULT_VARS,
              updateQuery: (prev, { subscriptionData }) => {
                const {
                  posts,
                  comments,
                  deletedPosts,
                  deletedComments,
                  pinnedPosts,
                  unpinnedPosts,
                  likedPosts,
                  unlikedPosts,
                  likedComments,
                  unlikedComments
                } = subscriptionData.data;
                let newData = fromJS(prev);

                const { user } = ownProps.client.readQuery({
                  query: USER_QUERY
                });

                // Check for updated posts.
                if (posts && posts.length > 0) {
                  const newPosts = filter(
                    posts,
                    post =>
                      !prev.posts.posts.find(p => p.id === post.id) &&
                      post.author
                  );
                  if (newPosts.length > 0) {
                    onNewPost && newPosts.forEach(onNewPost);
                    newData = newData.updateIn(['posts', 'posts'], list =>
                      fromJS(newPosts).concat(list)
                    );
                  }
                }

                // Check for updated comments.
                if (comments && comments.length > 0) {
                  const postComments = groupBy(comments, 'postId');
                  newData = newData.updateIn(['posts', 'posts'], list =>
                    list.map(post => {
                      if (!postComments[post.get('id')]) {
                        return post;
                      }

                      const curComments = post.getIn(['comments', 'comments']);
                      const newComments = filter(
                        postComments[post.get('id')],
                        comment =>
                          !curComments.find(c => c.get('id') === comment.id) &&
                          comment.author
                      ).map(newComment =>
                        Object.assign({}, newComment, {
                          likeCount: 0,
                          likedByMe: false
                        })
                      );
                      if (newComments.length > 0) {
                        onNewComment && newComments.forEach(onNewComment);
                        return post
                          .updateIn(['comments', 'comments'], list =>
                            fromJS(newComments).concat(list)
                          )
                          .set(
                            'commentCount',
                            post.get('commentCount') + newComments.length
                          );
                      }

                      return post;
                    })
                  );
                }

                // Check for liked posts.
                if (likedPosts && likedPosts.length > 0) {
                  const likedPostIds = likedPosts.map(post => post.id);
                  newData = newData.updateIn(['posts', 'posts'], list => {
                    return list.map(post => {
                      if (likedPostIds.includes(post.get('id'))) {
                        const likedPost = likedPosts.find(
                          likedPost => likedPost.id === post.get('id')
                        );
                        const likedByMe =
                          post.get('likedByMe') ||
                          likedPost.likedBy.userId === user.userId;

                        return post
                          .update('likeCount', count => count + 1)
                          .set('likedByMe', likedByMe)
                          .update('likedBy', lb => lb.concat(likedPost.likedBy))
                          .toJS();
                      } else {
                        return post;
                      }
                    });
                  });
                }

                // Check for unliked posts.
                if (unlikedPosts && unlikedPosts.length > 0) {
                  const unlikedPostIds = unlikedPosts.map(post => post.id);
                  newData = newData.updateIn(['posts', 'posts'], list => {
                    return list.map(post => {
                      if (unlikedPostIds.includes(post.get('id'))) {
                        const unlikedPost = unlikedPosts.find(
                          unlikedPost => unlikedPost.id === post.get('id')
                        );
                        const unlikedAccount = unlikedPost.userId;
                        const likedByMe =
                          post.get('likedByMe') &&
                          unlikedAccount !== user.userId;

                        return post
                          .update('likeCount', count => count - 1)
                          .set('likedByMe', likedByMe)
                          .update('likedBy', lb =>
                            lb.filter(u => u.get('userId') !== unlikedAccount)
                          )
                          .toJS();
                      } else {
                        return post;
                      }
                    });
                  });
                }

                // Check for deleted posts.
                if (deletedPosts && deletedPosts.length > 0) {
                  const deletedPostIds = deletedPosts.map(post => post.id);
                  newData = newData.updateIn(['posts', 'posts'], list =>
                    list.filter(
                      post => !deletedPostIds.includes(post.get('id'))
                    )
                  );

                  // Check if startId is one of the deleted posts, if it is then set startId to be first post.
                  if (
                    deletedPostIds.includes(newData.getIn(['posts', 'endId']))
                  ) {
                    newData = newData.setIn(
                      ['posts', 'startId'],
                      newData.getIn(['posts', 'posts']).count() > 0
                        ? newData
                            .getIn(['posts', 'posts'])
                            .first()
                            .get('id')
                        : ''
                    );
                  }

                  // Check if endId is one of the deleted posts, if it is then set endId to be last post.
                  if (
                    deletedPostIds.includes(newData.getIn(['posts', 'endId']))
                  ) {
                    newData = newData.setIn(
                      ['posts', 'endId'],
                      newData.getIn(['posts', 'posts']).count() > 0
                        ? newData
                            .getIn(['posts', 'posts'])
                            .last()
                            .get('id')
                        : ''
                    );
                  }
                }

                if (likedComments && likedComments.length > 0) {
                  const postLikedComments = groupBy(likedComments, 'postId');
                  newData = newData.updateIn(['posts', 'posts'], list => {
                    return list.map(post => {
                      if (postLikedComments[post.get('id')]) {
                        return post.updateIn(
                          ['comments', 'comments'],
                          commentsList => {
                            const likedCommentIds = postLikedComments[
                              post.get('id')
                            ].map(comment => comment.id);

                            return commentsList.map(comment => {
                              if (likedCommentIds.includes(comment.get('id'))) {
                                const likedComment = likedComments.find(
                                  likedComment =>
                                    likedComment.id === comment.get('id')
                                );
                                const likedByMe =
                                  comment.get('likedByMe') ||
                                  likedComment.likedBy.userId === user.userId;
                                const likeCount = comment.get('likeCount') + 1;

                                return comment
                                  .set('likeCount', likeCount)
                                  .set('likedByMe', likedByMe);
                              } else {
                                return comment;
                              }
                            });
                          }
                        );
                      } else {
                        return post;
                      }
                    });
                  });
                }

                if (unlikedComments && unlikedComments.length > 0) {
                  const postUnlikedComments = groupBy(
                    unlikedComments,
                    'postId'
                  );
                  newData = newData.updateIn(['posts', 'posts'], list => {
                    return list.map(post => {
                      if (postUnlikedComments[post.get('id')]) {
                        return post.updateIn(
                          ['comments', 'comments'],
                          commentsList => {
                            const unlikedCommentIds = postUnlikedComments[
                              post.get('id')
                            ].map(comment => comment.id);

                            return commentsList.map(comment => {
                              if (
                                unlikedCommentIds.includes(comment.get('id'))
                              ) {
                                const unlikedComment = unlikedComments.find(
                                  unlikedComment =>
                                    unlikedComment.id === comment.get('id')
                                );

                                const likedByMe =
                                  comment.get('likedByMe') &&
                                  unlikedComment.userId !== user.userId;
                                const likeCount = comment.get('likeCount') - 1;

                                return comment
                                  .set('likeCount', likeCount)
                                  .set('likedByMe', likedByMe);
                              } else {
                                return comment;
                              }
                            });
                          }
                        );
                      } else {
                        return post;
                      }
                    });
                  });
                }

                // Check for deleted comments.
                if (deletedComments && deletedComments.length > 0) {
                  const postDeletedComments = groupBy(
                    deletedComments,
                    'postId'
                  );
                  newData = newData.updateIn(['posts', 'posts'], list =>
                    list.map(post => {
                      if (postDeletedComments[post.get('id')]) {
                        const commentsToDelete = filter(
                          postDeletedComments[post.get('id')],
                          comment =>
                            !!post
                              .getIn(['comments', 'comments'])
                              .find(match => match.get('id') === comment.id)
                        );
                        const deletedCommentIds = commentsToDelete.map(
                          comment => comment.id
                        );
                        let newPost = post
                          .updateIn(['comments', 'comments'], list =>
                            list.filter(
                              comment =>
                                !deletedCommentIds.includes(comment.get('id'))
                            )
                          )
                          .set(
                            'commentCount',
                            post.get('commentCount') - deletedCommentIds.length
                          );

                        if (
                          deletedCommentIds.includes(
                            newPost.getIn(['comments', 'startId'])
                          )
                        ) {
                          newPost = newPost.setIn(
                            ['comments', 'startId'],
                            newPost.getIn(['comments', 'comments']).count() > 0
                              ? newPost
                                  .getIn(['comments', 'comments'])
                                  .first()
                                  .get('id')
                              : ''
                          );
                        }

                        // Check if endId is one of the deleted comments, if it is then set endId to be last comment.
                        if (
                          deletedCommentIds.includes(
                            newPost.getIn(['comments', 'endId'])
                          )
                        ) {
                          newPost = newPost.setIn(
                            ['comments', 'endId'],
                            newPost.getIn(['comments', 'comments']).count() > 0
                              ? newPost
                                  .getIn(['comments', 'comments'])
                                  .last()
                                  .get('id')
                              : ''
                          );
                        }

                        return newPost;
                      }

                      return post;
                    })
                  );
                }

                // Check if new pinned posts.
                if (pinnedPosts && pinnedPosts.length > 0) {
                  let pinnedPostIds = pinnedPosts.map(
                    pinnedPost => pinnedPost.post.id
                  );
                  newData = newData.updateIn(['posts', 'posts'], list => {
                    let newList = list.map(post => {
                      if (pinnedPostIds.includes(post.get('id'))) {
                        // Remove the element from the array.
                        pinnedPostIds = remove(pinnedPostIds, post.get('id'));
                        return post.set('isPinned', true);
                      }

                      return post;
                    });

                    // If pinned post was not already in the post data, then insert it.
                    if (pinnedPostIds.length > 0) {
                      const remainingPinnedPosts = filter(
                        pinnedPosts,
                        pinnedPost => pinnedPostIds.includes(pinnedPost.post.id)
                      ).map(pinnedPost => pinnedPost.post);
                      newList = fromJS(remainingPinnedPosts).concat(newList);
                    }

                    return newList;
                  });
                }

                // Check if unpinned posts.
                if (unpinnedPosts && unpinnedPosts.length > 0) {
                  const unpinnedPostIds = unpinnedPosts.map(post => post.id);
                  newData = newData.updateIn(['posts', 'posts'], list =>
                    list.map(post => {
                      return unpinnedPostIds.includes(post.get('id'))
                        ? post.set('isPinned', false)
                        : post;
                    })
                  );

                  newData = newData.updateIn(['posts', 'posts'], list => {
                    const unpinnedPost = unpinnedPostIds
                      ? list.find(post => post.get('id') === unpinnedPostIds[0])
                      : null;
                    const olderPosts = list.filter(post => {
                      return (
                        new Date(post.get('created')) <
                        new Date(unpinnedPost.get('created'))
                      );
                    });
                    const newerPosts = list.filter(post => {
                      return (
                        new Date(post.get('created')) >
                        new Date(unpinnedPost.get('created'))
                      );
                    });

                    if (olderPosts.length > 0) {
                      const newList = [
                        ...newerPosts.toJS(),
                        unpinnedPost,
                        ...olderPosts.toJS()
                      ];

                      return fromJS(newList);
                    } else {
                      return list;
                    }
                  });
                }

                return newData.toJS();
              }
            });
          }
        };
      }
    }),
    graphql(MUTATION_MAKE_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          postData: ownProps.postData,
          userData: ownProps.userData,
          makeWallPost: (message, imageKey) => {
            return mutate({
              variables: {
                post: {
                  message,
                  imageKey
                },
                posts: {
                  postCount: 1
                },
                comments: {
                  commentCount: 1
                }
              }
            });
          }
        };
      }
    }),
    graphql(MUTATION_DELETE_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          postData: ownProps.postData,
          userData: ownProps.userData,
          deleteWallPost: post => {
            return mutate({
              variables: { post: { id: post.id } }
            });
          }
        };
      }
    }),
    graphql(MUTATION_MAKE_WALL_COMMENT, {
      props({ ownProps, mutate }) {
        return {
          postData: ownProps.postData,
          userData: ownProps.userData,
          makeWallComment: (postId, comment) => {
            return mutate({
              variables: { comment: { postId, comment } }
            });
          }
        };
      }
    }),
    graphql(MUTATION_DELETE_WALL_COMMENT, {
      props({ ownProps, mutate }) {
        return {
          postData: ownProps.postData,
          userData: ownProps.userData,
          deleteWallComment: (postId, comment) => {
            return mutate({
              variables: { comment: { id: comment.id, postId } }
            });
          }
        };
      }
    }),
    graphql(MUTATION_PIN_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          postData: ownProps.postData,
          userData: ownProps.userData,
          pinWallPost: post => {
            return mutate({
              variables: {
                post: { id: post.id },
                posts: { mostRecentLikedByCount: 10, postCount: 1 }
              }
            });
          }
        };
      }
    }),
    graphql(MUTATION_UNPIN_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          postData: ownProps.postData,
          userData: ownProps.userData,
          unpinWallPost: post => {
            return mutate({
              variables: { post: { id: post.id } }
            });
          }
        };
      }
    }),
    graphql(MUTATION_LIKE_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          postData: ownProps.postData,
          userData: ownProps.userData,
          likePost: post => {
            return mutate({
              variables: { like: { id: post.id } }
            });
          }
        };
      }
    }),
    graphql(MUTATION_UNLIKE_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          postData: ownProps.postData,
          userData: ownProps.userData,
          unlikePost: post => {
            return mutate({
              variables: { unlike: { id: post.id } }
            });
          }
        };
      }
    }),
    graphql(MUTATION_LIKE_COMMENT, {
      props({ ownProps, mutate }) {
        return {
          postData: ownProps.postData,
          userData: ownProps.userData,
          likeComment: comment => {
            return mutate({
              variables: { like: { id: comment.id, postId: comment.postId } }
            });
          }
        };
      }
    }),
    graphql(MUTATION_UNLIKE_COMMENT, {
      props({ ownProps, mutate }) {
        return {
          postData: ownProps.postData,
          userData: ownProps.userData,
          unlikeComment: comment => {
            return mutate({
              variables: { unlike: { id: comment.id, postId: comment.postId } }
            });
          }
        };
      }
    })
  )(Feed)
);



// WEBPACK FOOTER //
// ./src/containers/Feed/index.js